/**
 * The web app's content security policy forbids eval. Zod probes for eval when
 * it builds its first object schema, which the shared package does as it
 * loads, so main.tsx imports this module before anything else.
 */
import { z } from 'zod';

z.config({ jitless: true });
